import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import home from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  /* {
    path: '/cwjr',
    meta: { title: '金融与财务学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/cwjr/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/cwjr/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/cwjr/lxwm.vue') },
      { path: 'ShowNews.aspx', meta: { title: '详情' }, component: () => import('../views/cwjr/ShowNews.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cwjr/zxdt.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cwjr/xsjz.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cwjr/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cwjr/luntan.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/cwjr/yjzx.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cwjr/xglj.vue') }
    ]
  }, */
  {
    path: '/xxgl',
    meta: { title: '信息管理与商业智能系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/xxgl/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/xxgl/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/xxgl/lxwm.vue') },
      { path: 'ShowNews.aspx', meta: { title: '详情' }, component: () => import('../views/cwjr/ShowNews.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/xxgl/zxdt.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/xxgl/xsjz.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/xxgl/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/xxgl/luntan.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/xxgl/yjzx.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/xxgl/xglj.vue') }
    ]
  },
  /* {
    path: '/cyjj_old_close',
    meta: { title: '应用经济学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/cyjj/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/cyjj/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  },
  {
    path: '/glkx',
    meta: { title: '管理科学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/glkx/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/glkx/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/glkx/lxwm.vue') },
      { path: 'ShowNews.aspx', meta: { title: '详情' }, component: () => import('../views/cwjr/ShowNews.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/glkx/zxdt.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/glkx/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/glkx/luntan.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  }, */
  {
    path: '/kjx',
    meta: { title: '会计学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/kjx/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/kjx/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  },
  {
    path: '/qygl',
    meta: { title: '企业管理系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/qygl/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/qygl/Index.vue') },
      // { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/cyjj/zhuanye.vue') },
      // { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      // { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cyjj/zhuanye.vue') },
      // { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/cyjj/zhuanye.vue') }
      // { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  },
  /* {
    path: '/scyx',
    meta: { title: '市场营销学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/scyx/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/scyx/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/scyx/lxwm.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/scyx/yjzx.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  },
  {
    path: '/tjxx',
    meta: { title: '统计与数据科学系' },
    component: home,
    children: [
      { path: '', meta: { title: '简介' }, component: () => import('../views/tjxx/Index.vue') },
      { path: 'index.aspx', meta: { title: '简介' }, component: () => import('../views/tjxx/Index.vue') },
      { path: 'lxwm.aspx', meta: { title: '联系我们' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zxdt.aspx', meta: { title: '最新动态' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'xsjz.aspx', meta: { title: '学术讲座' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'zhuanye.aspx', meta: { title: '专业介绍' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'luntan.aspx', meta: { title: '学术论坛' }, component: () => import('../views/cyjj/zhuanye.vue') },
      { path: 'yjzx.aspx', meta: { title: '研究中心' }, component: () => import('../views/tjxx/yjzx.vue') },
      { path: 'xglj.aspx', meta: { title: '相关链接' }, component: () => import('../views/cyjj/zhuanye.vue') }
    ]
  }, */
  {
    path: '/',
    redirect: '/qygl'
  },
  {
    path: '/video',
    component: () => import('../views/video.vue')
  },
  {
    path: '*',
    component: () => import('../views/error.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  base: process.env.NODE_ENV === 'production' ? '/department' : '/'
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // console.log(to)
  if (to.matched.length > 0) {
    store.commit('changeDepartName', to.matched[0].meta.title)
    store.commit('changeDepartPath', to.matched[0].path)
    store.commit('changePageTitle', to.meta.title)
    document.title = to.matched[0].meta.title + '~' + to.meta.title
  }
  // if (to.matched.length === 0) {
  //   from.name ? next({ name: from.name }) : next('/')
  // } else {
  // }
  next()
})
export default router
